export type PossibleTypesResultData = {
  possibleTypes: {
    CategoriesSlider: ['CategorySliderHighlight'];
    Content: [
      'ArtistService',
      'ArtistServiceFolder',
      'ArtistServicesPage',
      'AwardCategoryPage',
      'AwardsArtist',
      'AwardsCategoryMenu',
      'AwardsCategoryMenuDev',
      'AwardsCategoryMenuFolder',
      'AwardsCategoryMenuFolderDev',
      'AwardsHomepage',
      'CMSPage',
      'CategBgColor',
      'CategoryPage',
      'Channel',
      'ChannelFolder',
      'ChoiceNugget',
      'Collection',
      'ContentEditorFolder',
      'ContentTag',
      'ContentTags',
      'ContentTagsCateg',
      'Course',
      'CourseCategoriesFolder',
      'CourseCategory',
      'CourseExam',
      'CourseShare',
      'CourseStatus',
      'CourseTestProgression',
      'CourseUnit',
      'Discovery',
      'DiscoverySlide1',
      'EntrepreunarialHub',
      'FormFolder',
      'FormPage',
      'GapfillNugget',
      'HelpdeskCateg',
      'HelpdeskFolder',
      'HelpdeskPage',
      'HomePage',
      'JobBoardPage',
      'JobHub',
      'JobHubsFolder',
      'JobProgress',
      'JobShare',
      'JobTraining',
      'JobTrainingFolder',
      'JobVacanciesFolder',
      'JobVacancy',
      'LandingPage',
      'LearnMenu',
      'LegalsFolder',
      'ListenCateg',
      'LiveEvent',
      'LiveEventsMenu',
      'LiveEventsPage',
      'LiveTVPage',
      'MemberContentTypesLink',
      'MemberDatas',
      'MemberDownloaded',
      'MemberMessage',
      'MemberNotify',
      'MemberOpportunity',
      'MemberSaved',
      'MemberSearch',
      'MemberWatched',
      'MembersDatas',
      'MiniSitesFolder',
      'NavMessage',
      'NavigationMessagesFolder',
      'NetlifyDeploy',
      'News',
      'NewsCateg',
      'NewsFolder',
      'NewsPage',
      'ObtainedJob',
      'Opportunity',
      'OpportunityCenter',
      'OpportunityFolder',
      'Partner',
      'Partners',
      'PartnersPage',
      'Paywall',
      'PaywallFolder',
      'PersonalityPages',
      'PersonalityQuiz',
      'PersonalityQuiz1',
      'PersonalityType',
      'Playlist',
      'PlaylistRadioMenu',
      'Podcast',
      'PodcastCateg',
      'PodcastItem',
      'PodcastMenu',
      'PromoCode',
      'PromoCodeFolder',
      'QuizPage',
      'QuizzSurvey',
      'QuizzSurveyCategory',
      'QuizzSurveyCollection',
      'Radio',
      'RadioCateg',
      'Region',
      'SectionPage',
      'Settings',
      'Space',
      'Subscription',
      'SubscriptionData',
      'SubscriptionDataFolder',
      'SubscriptionsFolder',
      'SumaryNugget',
      'SurveyQuizzFolder',
      'TextPage',
      'ThankYouPage',
      'TranslationContext',
      'TranslationFolder',
      'TranslationItem',
      'UmbracoTest',
      'UnitNuggetAnswer',
      'UnitNuggetGapFillAnswer',
      'UnitProgression',
      'VODItem',
      'VODMenu',
      'VotingFolder',
      'VotingRecord',
      'WatchCateg',
    ];
    ContentDescriptionCmp: [
      'Collection',
      'LiveEvent',
      'Partner',
      'Podcast',
      'PodcastItem',
      'Subscription',
      'VODItem',
    ];
    ContentItems: [
      'Collection',
      'LiveEvent',
      'Playlist',
      'Podcast',
      'Radio',
      'VODItem',
    ];
    ContentLiveVideoCmp: ['UcAudio', 'UcVideo'];
    ContentTagsComp: ['Channel', 'News'];
    ContentsSlider: ['ContentSliderHighlight'];
    CoverImageCmp: ['Partner', 'Settings'];
    CoverThumbnailCmp: [
      'Channel',
      'Course',
      'PodcastItem',
      'QuizzSurveyCollection',
    ];
    CoverVideoCmp: [
      'ArtistService',
      'ArtistServicesPage',
      'AwardsHomepage',
      'CMSPage',
      'LandingPage',
      'PartnersPage',
      'Paywall',
      'PersonalityPages',
      'PersonalityQuiz',
      'QuizPage',
      'QuizzSurveyCollection',
      'ThankYouPage',
    ];
    DescriptionBlockCmp: ['Playlist', 'Radio'];
    Element: [
      'Accordions',
      'Advantage',
      'AdvantagesList',
      'Article',
      'ArtistService',
      'ArtistServiceFolder',
      'ArtistServicesPage',
      'Author',
      'AwardCategoryPage',
      'AwardsArtist',
      'AwardsCategoryMenu',
      'AwardsCategoryMenuDev',
      'AwardsCategoryMenuFolder',
      'AwardsCategoryMenuFolderDev',
      'AwardsHomepage',
      'Button',
      'CMSPage',
      'CTASlide',
      'CTASlider',
      'Card',
      'CardIcon',
      'CardLink',
      'CardList',
      'CategBgColor',
      'CategoryPage',
      'CategorySlider',
      'CategorySliderHighlight',
      'Channel',
      'ChannelFolder',
      'ChoiceNuggerAnswer',
      'ChoiceNugget',
      'ChoiceNuggetAnswerGroup',
      'ChoiceNuggetQuestion',
      'Collection',
      'ColorTag',
      'ContentAudioFileCmp',
      'ContentAudioVimeoCmp',
      'ContentCategCmp',
      'ContentEPGProgramFileCmp',
      'ContentEditorFolder',
      'ContentLink',
      'ContentSlider',
      'ContentSliderHighlight',
      'ContentTag',
      'ContentTags',
      'ContentTagsCateg',
      'ContextualContentSlider',
      'Course',
      'CourseCategoriesFolder',
      'CourseCategory',
      'CourseCategorySlider',
      'CourseExam',
      'CourseItemsSlider',
      'CourseNugget',
      'CoursePage',
      'CourseShare',
      'CourseStatus',
      'CourseTestProgression',
      'CourseUnit',
      'Discovery',
      'DiscoverySlide',
      'DiscoverySlide1',
      'EditoSlider',
      'EntrepreunarialHub',
      'ExpandMenu',
      'ExternalLink',
      'FaqItem',
      'FaqPageLink',
      'FormFolder',
      'FormPage',
      'Gallery',
      'GapFillNuggetAnswer',
      'GapFillNuggetImageAnswer',
      'GapfillNugget',
      'HelpdeskCateg',
      'HelpdeskFolder',
      'HelpdeskPage',
      'HeroBanner',
      'HeroBanner1',
      'HeroServices',
      'HeroSlide',
      'HeroVideoCover',
      'HomePage',
      'IconSlide',
      'InternalLink',
      'JobBoardPage',
      'JobHub',
      'JobHubsFolder',
      'JobProgress',
      'JobShare',
      'JobTraining',
      'JobTrainingFolder',
      'JobVacanciesFolder',
      'JobVacancy',
      'KeyFigure',
      'KeyFigures',
      'LandingAbout',
      'LandingPage',
      'LearnHeroSlide',
      'LearnMenu',
      'LegalPageLink',
      'LegalsFolder',
      'LinkIcon',
      'LinkPicker',
      'ListenCateg',
      'LiveEvent',
      'LiveEventsMenu',
      'LiveEventsPage',
      'LiveTVPage',
      'LogoLink',
      'LogoSlider',
      'MemberContentTypesLink',
      'MemberDatas',
      'MemberDownloaded',
      'MemberMessage',
      'MemberNotify',
      'MemberOpportunity',
      'MemberSaved',
      'MemberSearch',
      'MemberWatched',
      'MembersDatas',
      'MenuColumn',
      'MetadatasLanguages',
      'MetadatasVODLanguage',
      'MetasExclusives',
      'MetasPublicationDate',
      'MetasTrailerCmp',
      'MiniSitesFolder',
      'MultiSlider',
      'MulticategoriesSlider',
      'NavMessage',
      'NavigationMessagesFolder',
      'NetlifyDeploy',
      'News',
      'NewsCateg',
      'NewsFolder',
      'NewsPage',
      'NuggetsTextAnswerOption',
      'ObtainedJob',
      'Opportunity',
      'OpportunityCenter',
      'OpportunityFolder',
      'PageSEO',
      'PagecontentSlider',
      'Partner',
      'PartnerSlider',
      'Partners',
      'PartnersPage',
      'Paywall',
      'PaywallFolder',
      'PersonalityPages',
      'PersonalityPush',
      'PersonalityQuiz',
      'PersonalityQuiz1',
      'PersonalityQuizQuestion',
      'PersonalityType',
      'Playlist',
      'PlaylistRadioMenu',
      'Podcast',
      'PodcastCateg',
      'PodcastItem',
      'PodcastMenu',
      'PromoCode',
      'PromoCodeFolder',
      'Push',
      'QuizItemsSlider',
      'QuizPage',
      'QuizzSurvey',
      'QuizzSurveyCategory',
      'QuizzSurveyCollection',
      'Radio',
      'RadioCateg',
      'Region',
      'SectionPage',
      'Service',
      'ServicesList',
      'Settings',
      'SettingsAccessRestrictionCmp',
      'SettingsAccessRestrictionCmp1',
      'SettingsAccessRestrictionCmp2',
      'SettingsDateCmp',
      'SettingsExternalId',
      'Space',
      'StaticPageLink',
      'Subscription',
      'SubscriptionData',
      'SubscriptionDataFolder',
      'SubscriptionsFolder',
      'SubscriptionsList',
      'SumaryNugget',
      'SummaryNuggetStatement',
      'SurveyQuizzFolder',
      'TextPage',
      'TextSlide1',
      'ThankYouPage',
      'TitleSlider',
      'Top10Song',
      'TranslationContext',
      'TranslationFolder',
      'TranslationItem',
      'TutorialSlide',
      'UcAudio',
      'UcImage',
      'UcLineBreak',
      'UcText',
      'UcVideo',
      'UmbracoTest',
      'UnitNuggetAnswer',
      'UnitNuggetGapFillAnswer',
      'UnitNuggetGapFillAnswerItem',
      'UnitProgression',
      'VODItem',
      'VODMenu',
      'ValidationElement',
      'VotingFolder',
      'VotingRecord',
      'WatchCateg',
      'WatchedContent',
      'Wysiwyg',
    ];
    HeroSliderCmp: ['JobBoardPage', 'SectionPage'];
    ListenMenu: ['PlaylistRadioMenu', 'PodcastMenu'];
    Media: [
      'File',
      'Folder',
      'Image',
      'UmbracoMediaArticle',
      'UmbracoMediaAudio',
      'UmbracoMediaVectorGraphics',
      'UmbracoMediaVideo',
    ];
    MemberContentTemplate: [
      'MemberDownloaded',
      'MemberNotify',
      'MemberSaved',
      'MemberWatched',
    ];
    MetasAuthorCmp: ['News', 'Playlist', 'Podcast', 'Radio', 'VODItem'];
    MetasVideosCmp: ['Collection', 'Podcast', 'PodcastItem', 'VODItem'];
    NuggetFeedbackCmp: ['ChoiceNugget', 'GapfillNugget', 'SumaryNugget'];
    Page: [
      'CMSPage',
      'CategoryPage',
      'FormPage',
      'HelpdeskPage',
      'HomePage',
      'JobBoardPage',
      'LiveEventsPage',
      'LiveTVPage',
      'NewsPage',
      'PartnersPage',
      'SectionPage',
      'ThankYouPage',
    ];
    SliderHighlight: ['CategorySliderHighlight', 'ContentSliderHighlight'];
    SliderThumbnailSettings: [
      'CategorySlider',
      'CategorySliderHighlight',
      'ContentSlider',
      'ContentSliderHighlight',
      'ContextualContentSlider',
      'CourseCategorySlider',
      'CourseItemsSlider',
      'MulticategoriesSlider',
      'PagecontentSlider',
      'QuizItemsSlider',
    ];
    Top10Cmp: ['Playlist', 'Radio'];
    TopMenuComp: ['CMSPage', 'JobBoardPage', 'SectionPage'];
    WatchMenu: ['LiveEventsMenu', 'VODMenu'];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    CategoriesSlider: ['CategorySliderHighlight'],
    Content: [
      'ArtistService',
      'ArtistServiceFolder',
      'ArtistServicesPage',
      'AwardCategoryPage',
      'AwardsArtist',
      'AwardsCategoryMenu',
      'AwardsCategoryMenuDev',
      'AwardsCategoryMenuFolder',
      'AwardsCategoryMenuFolderDev',
      'AwardsHomepage',
      'CMSPage',
      'CategBgColor',
      'CategoryPage',
      'Channel',
      'ChannelFolder',
      'ChoiceNugget',
      'Collection',
      'ContentEditorFolder',
      'ContentTag',
      'ContentTags',
      'ContentTagsCateg',
      'Course',
      'CourseCategoriesFolder',
      'CourseCategory',
      'CourseExam',
      'CourseShare',
      'CourseStatus',
      'CourseTestProgression',
      'CourseUnit',
      'Discovery',
      'DiscoverySlide1',
      'EntrepreunarialHub',
      'FormFolder',
      'FormPage',
      'GapfillNugget',
      'HelpdeskCateg',
      'HelpdeskFolder',
      'HelpdeskPage',
      'HomePage',
      'JobBoardPage',
      'JobHub',
      'JobHubsFolder',
      'JobProgress',
      'JobShare',
      'JobTraining',
      'JobTrainingFolder',
      'JobVacanciesFolder',
      'JobVacancy',
      'LandingPage',
      'LearnMenu',
      'LegalsFolder',
      'ListenCateg',
      'LiveEvent',
      'LiveEventsMenu',
      'LiveEventsPage',
      'LiveTVPage',
      'MemberContentTypesLink',
      'MemberDatas',
      'MemberDownloaded',
      'MemberMessage',
      'MemberNotify',
      'MemberOpportunity',
      'MemberSaved',
      'MemberSearch',
      'MemberWatched',
      'MembersDatas',
      'MiniSitesFolder',
      'NavMessage',
      'NavigationMessagesFolder',
      'NetlifyDeploy',
      'News',
      'NewsCateg',
      'NewsFolder',
      'NewsPage',
      'ObtainedJob',
      'Opportunity',
      'OpportunityCenter',
      'OpportunityFolder',
      'Partner',
      'Partners',
      'PartnersPage',
      'Paywall',
      'PaywallFolder',
      'PersonalityPages',
      'PersonalityQuiz',
      'PersonalityQuiz1',
      'PersonalityType',
      'Playlist',
      'PlaylistRadioMenu',
      'Podcast',
      'PodcastCateg',
      'PodcastItem',
      'PodcastMenu',
      'PromoCode',
      'PromoCodeFolder',
      'QuizPage',
      'QuizzSurvey',
      'QuizzSurveyCategory',
      'QuizzSurveyCollection',
      'Radio',
      'RadioCateg',
      'Region',
      'SectionPage',
      'Settings',
      'Space',
      'Subscription',
      'SubscriptionData',
      'SubscriptionDataFolder',
      'SubscriptionsFolder',
      'SumaryNugget',
      'SurveyQuizzFolder',
      'TextPage',
      'ThankYouPage',
      'TranslationContext',
      'TranslationFolder',
      'TranslationItem',
      'UmbracoTest',
      'UnitNuggetAnswer',
      'UnitNuggetGapFillAnswer',
      'UnitProgression',
      'VODItem',
      'VODMenu',
      'VotingFolder',
      'VotingRecord',
      'WatchCateg',
    ],
    ContentDescriptionCmp: [
      'Collection',
      'LiveEvent',
      'Partner',
      'Podcast',
      'PodcastItem',
      'Subscription',
      'VODItem',
    ],
    ContentItems: [
      'Collection',
      'LiveEvent',
      'Playlist',
      'Podcast',
      'Radio',
      'VODItem',
    ],
    ContentLiveVideoCmp: ['UcAudio', 'UcVideo'],
    ContentTagsComp: ['Channel', 'News'],
    ContentsSlider: ['ContentSliderHighlight'],
    CoverImageCmp: ['Partner', 'Settings'],
    CoverThumbnailCmp: [
      'Channel',
      'Course',
      'PodcastItem',
      'QuizzSurveyCollection',
    ],
    CoverVideoCmp: [
      'ArtistService',
      'ArtistServicesPage',
      'AwardsHomepage',
      'CMSPage',
      'LandingPage',
      'PartnersPage',
      'Paywall',
      'PersonalityPages',
      'PersonalityQuiz',
      'QuizPage',
      'QuizzSurveyCollection',
      'ThankYouPage',
    ],
    DescriptionBlockCmp: ['Playlist', 'Radio'],
    Element: [
      'Accordions',
      'Advantage',
      'AdvantagesList',
      'Article',
      'ArtistService',
      'ArtistServiceFolder',
      'ArtistServicesPage',
      'Author',
      'AwardCategoryPage',
      'AwardsArtist',
      'AwardsCategoryMenu',
      'AwardsCategoryMenuDev',
      'AwardsCategoryMenuFolder',
      'AwardsCategoryMenuFolderDev',
      'AwardsHomepage',
      'Button',
      'CMSPage',
      'CTASlide',
      'CTASlider',
      'Card',
      'CardIcon',
      'CardLink',
      'CardList',
      'CategBgColor',
      'CategoryPage',
      'CategorySlider',
      'CategorySliderHighlight',
      'Channel',
      'ChannelFolder',
      'ChoiceNuggerAnswer',
      'ChoiceNugget',
      'ChoiceNuggetAnswerGroup',
      'ChoiceNuggetQuestion',
      'Collection',
      'ColorTag',
      'ContentAudioFileCmp',
      'ContentAudioVimeoCmp',
      'ContentCategCmp',
      'ContentEPGProgramFileCmp',
      'ContentEditorFolder',
      'ContentLink',
      'ContentSlider',
      'ContentSliderHighlight',
      'ContentTag',
      'ContentTags',
      'ContentTagsCateg',
      'ContextualContentSlider',
      'Course',
      'CourseCategoriesFolder',
      'CourseCategory',
      'CourseCategorySlider',
      'CourseExam',
      'CourseItemsSlider',
      'CourseNugget',
      'CoursePage',
      'CourseShare',
      'CourseStatus',
      'CourseTestProgression',
      'CourseUnit',
      'Discovery',
      'DiscoverySlide',
      'DiscoverySlide1',
      'EditoSlider',
      'EntrepreunarialHub',
      'ExpandMenu',
      'ExternalLink',
      'FaqItem',
      'FaqPageLink',
      'FormFolder',
      'FormPage',
      'Gallery',
      'GapFillNuggetAnswer',
      'GapFillNuggetImageAnswer',
      'GapfillNugget',
      'HelpdeskCateg',
      'HelpdeskFolder',
      'HelpdeskPage',
      'HeroBanner',
      'HeroBanner1',
      'HeroServices',
      'HeroSlide',
      'HeroVideoCover',
      'HomePage',
      'IconSlide',
      'InternalLink',
      'JobBoardPage',
      'JobHub',
      'JobHubsFolder',
      'JobProgress',
      'JobShare',
      'JobTraining',
      'JobTrainingFolder',
      'JobVacanciesFolder',
      'JobVacancy',
      'KeyFigure',
      'KeyFigures',
      'LandingAbout',
      'LandingPage',
      'LearnHeroSlide',
      'LearnMenu',
      'LegalPageLink',
      'LegalsFolder',
      'LinkIcon',
      'LinkPicker',
      'ListenCateg',
      'LiveEvent',
      'LiveEventsMenu',
      'LiveEventsPage',
      'LiveTVPage',
      'LogoLink',
      'LogoSlider',
      'MemberContentTypesLink',
      'MemberDatas',
      'MemberDownloaded',
      'MemberMessage',
      'MemberNotify',
      'MemberOpportunity',
      'MemberSaved',
      'MemberSearch',
      'MemberWatched',
      'MembersDatas',
      'MenuColumn',
      'MetadatasLanguages',
      'MetadatasVODLanguage',
      'MetasExclusives',
      'MetasPublicationDate',
      'MetasTrailerCmp',
      'MiniSitesFolder',
      'MultiSlider',
      'MulticategoriesSlider',
      'NavMessage',
      'NavigationMessagesFolder',
      'NetlifyDeploy',
      'News',
      'NewsCateg',
      'NewsFolder',
      'NewsPage',
      'NuggetsTextAnswerOption',
      'ObtainedJob',
      'Opportunity',
      'OpportunityCenter',
      'OpportunityFolder',
      'PageSEO',
      'PagecontentSlider',
      'Partner',
      'PartnerSlider',
      'Partners',
      'PartnersPage',
      'Paywall',
      'PaywallFolder',
      'PersonalityPages',
      'PersonalityPush',
      'PersonalityQuiz',
      'PersonalityQuiz1',
      'PersonalityQuizQuestion',
      'PersonalityType',
      'Playlist',
      'PlaylistRadioMenu',
      'Podcast',
      'PodcastCateg',
      'PodcastItem',
      'PodcastMenu',
      'PromoCode',
      'PromoCodeFolder',
      'Push',
      'QuizItemsSlider',
      'QuizPage',
      'QuizzSurvey',
      'QuizzSurveyCategory',
      'QuizzSurveyCollection',
      'Radio',
      'RadioCateg',
      'Region',
      'SectionPage',
      'Service',
      'ServicesList',
      'Settings',
      'SettingsAccessRestrictionCmp',
      'SettingsAccessRestrictionCmp1',
      'SettingsAccessRestrictionCmp2',
      'SettingsDateCmp',
      'SettingsExternalId',
      'Space',
      'StaticPageLink',
      'Subscription',
      'SubscriptionData',
      'SubscriptionDataFolder',
      'SubscriptionsFolder',
      'SubscriptionsList',
      'SumaryNugget',
      'SummaryNuggetStatement',
      'SurveyQuizzFolder',
      'TextPage',
      'TextSlide1',
      'ThankYouPage',
      'TitleSlider',
      'Top10Song',
      'TranslationContext',
      'TranslationFolder',
      'TranslationItem',
      'TutorialSlide',
      'UcAudio',
      'UcImage',
      'UcLineBreak',
      'UcText',
      'UcVideo',
      'UmbracoTest',
      'UnitNuggetAnswer',
      'UnitNuggetGapFillAnswer',
      'UnitNuggetGapFillAnswerItem',
      'UnitProgression',
      'VODItem',
      'VODMenu',
      'ValidationElement',
      'VotingFolder',
      'VotingRecord',
      'WatchCateg',
      'WatchedContent',
      'Wysiwyg',
    ],
    HeroSliderCmp: ['JobBoardPage', 'SectionPage'],
    ListenMenu: ['PlaylistRadioMenu', 'PodcastMenu'],
    Media: [
      'File',
      'Folder',
      'Image',
      'UmbracoMediaArticle',
      'UmbracoMediaAudio',
      'UmbracoMediaVectorGraphics',
      'UmbracoMediaVideo',
    ],
    MemberContentTemplate: [
      'MemberDownloaded',
      'MemberNotify',
      'MemberSaved',
      'MemberWatched',
    ],
    MetasAuthorCmp: ['News', 'Playlist', 'Podcast', 'Radio', 'VODItem'],
    MetasVideosCmp: ['Collection', 'Podcast', 'PodcastItem', 'VODItem'],
    NuggetFeedbackCmp: ['ChoiceNugget', 'GapfillNugget', 'SumaryNugget'],
    Page: [
      'CMSPage',
      'CategoryPage',
      'FormPage',
      'HelpdeskPage',
      'HomePage',
      'JobBoardPage',
      'LiveEventsPage',
      'LiveTVPage',
      'NewsPage',
      'PartnersPage',
      'SectionPage',
      'ThankYouPage',
    ],
    SliderHighlight: ['CategorySliderHighlight', 'ContentSliderHighlight'],
    SliderThumbnailSettings: [
      'CategorySlider',
      'CategorySliderHighlight',
      'ContentSlider',
      'ContentSliderHighlight',
      'ContextualContentSlider',
      'CourseCategorySlider',
      'CourseItemsSlider',
      'MulticategoriesSlider',
      'PagecontentSlider',
      'QuizItemsSlider',
    ],
    Top10Cmp: ['Playlist', 'Radio'],
    TopMenuComp: ['CMSPage', 'JobBoardPage', 'SectionPage'],
    WatchMenu: ['LiveEventsMenu', 'VODMenu'],
  },
};
export default result;
